type IfProps = {
  cond: boolean;
  children: React.ReactNode;
};

const If: React.FC<IfProps> = ({ cond, children }) => {
  return cond ? <>{children}</> : null;
};

export default If;
